/**
 * Framer Motion path-drawing animation for CircleHoverCta.
 * Not a static SVG — cannot be used as <Icon name="..." />.
 * Accepts `hovered` to drive the pathLength animation.
 */

import type { CSSProperties, ReactElement } from 'react';
import { motion } from 'framer-motion';

const SKETCHY_ELLIPSE = 'M 14,32 C 10,6 52,-4 102,-2 C 152,0 192,8 194,32 C 196,56 154,66 102,64 C 50,62 18,58 14,32';

export function SketchyEllipseIcon({
	hovered,
	color = 'currentColor',
	style
}: {
	hovered: boolean;
	color?: string;
	style?: CSSProperties;
}): ReactElement {
	return (
		<svg
			role="presentation"
			viewBox="0 0 208 64"
			preserveAspectRatio="none"
			style={{
				position: 'absolute',
				inset: 0,
				width: '100%',
				height: '100%',
				overflow: 'visible',
				pointerEvents: 'none',
				...style
			}}
		>
			<motion.path
				d={SKETCHY_ELLIPSE}
				stroke={color}
				strokeWidth="2"
				fill="none"
				strokeLinecap="round"
				vectorEffect="non-scaling-stroke"
				initial={{ pathLength: 0, opacity: 0 }}
				animate={{
					pathLength: hovered ? 1 : 0,
					opacity: hovered ? 1 : 0
				}}
				transition={{
					pathLength: { duration: 0.45, ease: 'easeInOut' },
					opacity: { duration: 0.01 }
				}}
			/>
		</svg>
	);
}
